import React from 'react';
import BaseProtocol from '../Application/BaseProtocol';
import { MSW_PROTOCOL_ITEMS } from './mswProtocolConstants';

const MswProtocol = ({ targetUserId, onClose }) => {
    return (
        <BaseProtocol
            role="MSW"
            title="MSW JOB DESCRIPTION"
            items={MSW_PROTOCOL_ITEMS}
            apiEndpoint="/job-descriptions"
            fetchEndpoint="/job-descriptions"
            defaultValues={{
                userId: targetUserId
            }}
            onClose={onClose}
        />
    );
};

export default MswProtocol;
